import React from 'react';
import PropTypes from 'prop-types';
import { graphql, compose } from 'react-apollo';
import withStyles from 'isomorphic-style-loader/lib/withStyles';

import Loader from '../../../components/Loader';
import ManagePayout from '../../../components/siteadmin/ManagePayout/ManagePayout';

import reservationsQuery from './reservationsQuery.graphql';

import s from "./PayoutManagement.css";
class PayoutManagement extends React.Component {
    static propTypes = {
        title: PropTypes.string.isRequired,
        data: PropTypes.shape({
            loading: PropTypes.bool,
            getAllPayoutReservation: PropTypes.array,
        })
    }

    render() {
        const {  getAllPayouts, title } = this.props;
        return <ManagePayout
            getAllPayouts={getAllPayouts}
            title={title}
        />
    }
}

export default compose(
    withStyles(s),
    graphql(reservationsQuery, {
        name: 'getAllPayouts',
        options: {
            variables: {
                currentPage: 1,
                searchList: ''
            },
            fetchPolicy: 'network-only',
        }
    })
)(PayoutManagement);